import { BaseDesignOption } from '@/modules/ta/reportstudio/models/element/metadata/BaseDesignOption';

export class ShapeDesignOption extends BaseDesignOption {
  /**
   * @type {boolean}
   */
  show_on_every_page;

  /**
   * @type {string}
   */
  border_radius;

  /**
   * @type {string}
   */
  background_color;

  constructor(model = {}) {
    super();
    this.show_on_every_page = model.show_on_every_page ?? true;
    this.border_radius = model.border_radius ?? '0%';
    this.background_color = model.background_color;
  }
}
